var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.id)?_c('iframe',{staticClass:"ab-video-youtube",attrs:{"src":`https://www.youtube.com/embed/${_vm.id}?rel=0`,"title":_vm.title,"frameborder":"0","allow":"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }